import { Injectable } from '@angular/core';
import { environment } from "../../../environments/environment";
import { CaqRequestService } from "../caq-request/caq-request.service";
import { Observable } from "rxjs";
import { DadosRelatorioCaqDto } from "../../dtos/caq-por-etapa-dto";
import { LocalizacaoService } from '../localizacao/localizacao.service';
import { TipoSimulacao } from '../../enums/simulation-type.enum';

@Injectable({
  providedIn: 'root'
})
export class RelatorioCaqService {
  private apiUrl = `${environment.apiUrl}/simulador/caq`;

  constructor(
    private caqRequestService: CaqRequestService,
    private localizacaoService: LocalizacaoService
  ) { }

  solicitarRelatorioCaqNacional(): Observable<DadosRelatorioCaqDto> {
    return this.caqRequestService
      .get<DadosRelatorioCaqDto>(`${this.apiUrl}/nacional`);
  }

  solicitarRelatorioCaqPorLocalizacao(): Observable<DadosRelatorioCaqDto> {
    const url = this.construirUrlRelatorioCaq();
    return this.caqRequestService.get<DadosRelatorioCaqDto>(url);
  }

  private construirUrlRelatorioCaq(): string {
    const localizacao = this.localizacaoService.obterLocalizacaoSelecionada();

    if (!localizacao) {
      return `${this.apiUrl}/nacional`;
    }

    const tipo = localizacao.tipoSimulacaoSelecionado;

    if (tipo === TipoSimulacao.planejamentoNacional) {
      return `${this.apiUrl}/nacional`;
    }

    if (localizacao.cidadeSelecionada) {
      const codMun = localizacao.cidadeSelecionada.value;

      if (tipo === TipoSimulacao.planejamento) {
        return `${this.apiUrl}/plano-municipal/${codMun}`;
      } else if (tipo === TipoSimulacao.planejamentoPorEsferaAdmMunicipal) {
        return `${this.apiUrl}/rede-municipal/${codMun}`;
      }
    }

    if (localizacao.estadoSelecionado) {
      const codUf = localizacao.estadoSelecionado.value;

      if (tipo === TipoSimulacao.planejamento) {
        return `${this.apiUrl}/plano-estadual/${codUf}`;
      } else if (tipo === TipoSimulacao.planejamentoPorEsferaAdmEstadual) {
        return `${this.apiUrl}/rede-estatual/${codUf}`;
      }
    }

    throw new Error('Tipo de simulação ou localização inválida');
  }
}
